import React, { useState, useEffect } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { StorageHandler, RewardMenu, APIHandler, ContentHeader, locales } from 'C4';
import { storageKeys, baseAppId, language } from 'settings';
import i18n from 'i18n-react';

const ALLOWED_COUNTRIES = ['gb', 'de', 'fr', 'au']; // List of allowed countries

const RewardsView = () => {
  const [email, setEmail] = useState('');
  const [points, setPoints] = useState([]);
  const [isAllowed, setIsAllowed] = useState(false);

  const params = new URLSearchParams(window.location.search);
  let mobile = false;
  if (params.get("mobile")) {
    mobile = true;
  }

  useEffect(() => {
    const checkCountry = async () => {
      const langData = await StorageHandler.load(storageKeys.lang);
      const countryCode = langData?.code?.toLowerCase();
      setIsAllowed(ALLOWED_COUNTRIES.includes(countryCode));
    };

    checkCountry();
  }, []);

  useEffect(() => {
    if (!(points.total >= 0)) {
      StorageHandler.load(storageKeys.accessToken).then((token) => {
        const startDate = '2021-07-21';
        const endDate = '2023-12-21';
        APIHandler.getPoints(baseAppId, startDate, endDate, token).then((res) => {
          setPoints(res.total);
        });
      });
    }
  }, [points, setPoints]);

  useEffect(() => {
    document.body.classList.remove("no-scroll");
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        setEmail((prev) => (res.email !== prev ? res.email : prev));
      }
    });
    if (mobile) {
      // Save token and email from URL params
      const token = params.get("token");
      const lang = params.get("lang");

      if (lang) {
        const newLanguageCode = params.get("lang").toLowerCase();
        // console.log('newLanguageCode', newLanguageCode);
        i18n.setTexts(locales[newLanguageCode]);
        const newCountry = language.filter(
          (langSettings) => langSettings.langFile === newLanguageCode
        )[0].countries[0];
        StorageHandler.save(storageKeys.lang, {
          country: newCountry,
          code: newLanguageCode.toUpperCase(),
          langFile: newLanguageCode,
        });
        // console.log('newCountry', newCountry);
      } else {
        StorageHandler.load(storageKeys.lang).then((lang) => {
          i18n.setTexts(locales[lang.langFile]);
        });
      }

      // If there is no token in the url, check the validity of the token currently stored.
      if (!token) {

        // Get token expiration date
        let accessToken = localStorage.getItem("accessToken");
        if (accessToken) {
          accessToken = JSON.parse(accessToken);
          const expiration = accessToken.expires;
          if (expiration) {
            // Check if token is expired
            const now = new Date();
            const expirationDate = new Date(expiration);
            if (now >= expirationDate) {
              // Token is expired
              this.setState({ loggedIn: false });
              // Remove token from storage
              StorageHandler.remove(storageKeys.accessToken);
              StorageHandler.remove(storageKeys.user);
            }
          }
        }

        return;
      }

      const thirtyDaysInMilliseconds = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds
      const now = new Date();
      const expires = new Date(now.getTime() + thirtyDaysInMilliseconds);

      const user = {
        email: params.get("email"),
        expires: expires.getTime(),
      };

      StorageHandler.save(storageKeys.user, user);

      if (token) {
        console.log("Token from URL: ", token);

        // Expecting to have a token
        StorageHandler.save(storageKeys.accessToken, token);

      }

      setEmail(params.get("email") || "");
    }
  }, [email, setEmail, mobile, params]);

  return (
    <div className="contentContainer rewardsView">
      <RewardMenu />

      <div className="bodyRewards">
        <div className="holder">
          <ContentHeader header={i18n.translate('rewards.title')} subtitle={i18n.translate('rewards.subheader')} />

          <hr />

          <div className="rewardsCenter">

            <div className="rewardsCenter__content">
              <h4>
                <b>{i18n.translate('rewards.overview.subtitle')}</b>
                <br /> <br />
                {i18n.translate('rewards.overview.description')}
                <br />
              </h4>
              <ul>
                <li>
                  <h2>{i18n.translate('rewards.overview.dashboard.title')}</h2>
                </li>
                <li>{i18n.translate('rewards.overview.dashboard.description')}</li>
              </ul>
              <ul>
                <li>{i18n.translate('rewards.overview.dashboard.bronze')}</li>
                <li>{i18n.translate('rewards.overview.dashboard.silver')}</li>
                <li>{i18n.translate('rewards.overview.dashboard.gold')}</li>
                <li>{i18n.translate('rewards.overview.dashboard.platinum')}</li>
              </ul>
              <ul>
                <li>
                  <h2>{i18n.translate('rewards.overview.platinumRewards.title')}</h2>
                </li>
                <li>{i18n.translate('rewards.overview.platinumRewards.description')}</li>
              </ul>
              <ul>
                <li>
                  <h2>{i18n.translate('rewards.overview.downloads.title')}</h2>
                </li>
                <li>{i18n.translate('rewards.overview.downloads.description')}</li>
              </ul>
            </div>
          </div>

          <hr />

          <Link to="/main/rewards/achievements" className="linkRewards">
            <ContentHeader
              icon={['fas', 'bars']}
              header={i18n.translate('rewards.home.trainingAchievements')}
              subtitle={i18n.translate('rewards.home.trainingAchievementsText')}
              layout="row"
            />
          </Link>

          <hr />

          {/* Show these only if the country is allowed */}
          {isAllowed && (
            <>
              <Link to="/main/rewards/bookings" className="linkRewards">
                <ContentHeader
                  icon={['far', 'badge']}
                  header={i18n.translate('rewards.home.bookingDashboard')}
                  subtitle={i18n.translate('rewards.home.bookingDashboardText')}
                  layout="row"
                />
              </Link>

              <hr />

              <Link to="/main/rewards/form" className="linkRewards">
                <ContentHeader
                  icon="upload"
                  header={i18n.translate('rewards.home.submitBooking')}
                  subtitle={i18n.translate('rewards.home.submitBookingText')}
                  layout="row"
                />
              </Link>

              <hr />
            </>
          )}
        </div>
      </div>

      {mobile && (
        <style>
          {
            "\
    #CookiebotWidget { display: none !important; } .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; } "
          }
          {".thankYouView__wrapper { margin-top: 5rem !important; }"}
        </style>
      )}
    </div>
  );
};

export default RewardsView;
